import styled from "styled-components";
export const Caret = styled.div.withConfig({
  displayName: "Caret",
  componentId: "sc-sl1sku-0"
})(["content:\"\";display:block;position:absolute;z-index:", ";height:", ";width:", ";background:", ";transform:rotate(45deg);"], props => props.zIndex ? "".concat(props.zIndex) : "-1", props => props.size ? "".concat(props.size, "px") : "20px", props => props.size ? "".concat(props.size, "px") : "20px", props => props.background ? "".concat(props.background) : "".concat(props.theme.textLight));
export default Caret;